/**
 * Platform detection for keyboard modifiers.
 *
 * The Meta key is Command on Apple hardware and the Windows key elsewhere. Using
 * it as a gesture modifier on Windows is a trap: a lone press of the Windows key
 * opens the Start menu when released, and no web page can prevent that. Canvas
 * gestures therefore use Ctrl outside Apple platforms.
 */

const APPLE_PLATFORM = /Mac|iPhone|iPad|iPod/i;

export const isApplePlatform = (): boolean => {
    if (typeof navigator === 'undefined') return false;
    const platform =
        (navigator as Navigator & { userAgentData?: { platform?: string } }).userAgentData?.platform
        || navigator.platform
        || '';
    return APPLE_PLATFORM.test(platform);
};

/** Whether a wheel event carries the zoom modifier for this platform. */
export const hasZoomModifier = (e: { ctrlKey: boolean; metaKey: boolean }): boolean =>
    e.ctrlKey || (e.metaKey && isApplePlatform());

/** The key name shown in hints: Command on Apple platforms, Ctrl elsewhere. */
export const zoomModifierLabel = (): string => (isApplePlatform() ? '⌘' : 'Ctrl');
